import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-glow" />

      <div className="hero-content">
        {/* ── text ── */}
        <div className="hero-text">
          <div className="hero-badge">Our Games</div>
          <h1 className="hero-title">
            Games that<br />
            we <span className="accent">Launch</span>
          </h1>
          <p className="hero-desc">
            We build immersive, high-performance games and digital
            experiences. From concept to launch, from mobile to
            cross-platform titles, we turn ideas into engaging products players
            love.
          </p>
          <a href="#trending" className="btn-primary">Get more details</a>
        </div>

        {/* ── logo icon card ── */}
        <div className="hero-logo-wrap">
          <img src="/logo-icon.png" alt="iG logo" className="hero-logo-img" />
        </div>
      </div>
    </section>
  );
}
